module.exports = __webpack_public_path__ + "img/home-index-menu13.d7dddc77.png";